@if (hasValues) {
  <table class="table table-striped" (scroll)="onScroll($event)">
    <thead>
      <!-- Column Names -->
      <tr>
        @for (col of data.columns; track col) {
          <th scope="col">
            {{col.header}} @if (col.sortable) {
            <i class="fa-solid fa-sort sort" (click)="sortBy(col)"></i>
          }
        </th>
      }
    </tr>
    <!-- Filter -->
    @if (hasFilterableRows) {
      <tr>
        @for (col of data.columns; track col) {
          <td>
            @if (col.filterable) {
              <input type="text" class="form-control" [(ngModel)]="col.filter">
            }
          </td>
        }
      </tr>
    }
  </thead>
  <tbody>
    <!-- Data -->
    @for (row of visibleData; track row) {
      <tr (click)="onRowClicked(row)">
        @for (col of data.columns; track col) {
          <td>
            {{row[col.field]}}
          </td>
        }
      </tr>
    }
  </tbody>
</table>
}